var SelectCityDataTestIdEnum = /* @__PURE__ */ ((SelectCityDataTestIdEnum2) => {
  SelectCityDataTestIdEnum2["SELECT_CITIES_BUTTON_TRIGGER_SELECT_CITIES"] = "select-cities-button-trigger-select-cities";
  SelectCityDataTestIdEnum2["SELECT_CITIES_COMMAND_INPUT"] = "select-cities-command-input";
  SelectCityDataTestIdEnum2["SELECT_CITIES_COMMAND_ITEM"] = "select-cities-command-item";
  SelectCityDataTestIdEnum2["SELECT_CITIES_COMMAND_EMPTY"] = "select-cities-command-empty";
  SelectCityDataTestIdEnum2["SELECT_CITIES_CLEAR_BUTTON"] = "select-cities-clear-button";
  return SelectCityDataTestIdEnum2;
})(SelectCityDataTestIdEnum || {});
export {
  SelectCityDataTestIdEnum
};
